module.exports = __webpack_public_path__ + "static/media/comment-icon.4fbda5a2.svg";